import React, { ChangeEvent, ClipboardEvent } from 'react';
import CustomTextField from 'components/CustomTextField';
import { WebsiteTextFieldProps } from './WebsiteTextField.props';

const WebsiteTextField = ({
  id,
  type,
  name,
  label,
  value = '',
  onChange,
  formErrors = {},
  dbErrors = {},
  ...restProps
}: WebsiteTextFieldProps) => {
  const onWebsiteFocus = () => {
    if (!value?.length) {
      const syntheticEvent = {
        target: { name, value: 'https://' },
        currentTarget: { name, value: 'https://' },
        preventDefault: () => {},
        stopPropagation: () => {},
        persist: () => {},
        nativeEvent: new Event('input'),
      };
      onChange(syntheticEvent as ChangeEvent<HTMLInputElement>);
    }
  };

  const onURLPaste = (event: ClipboardEvent<HTMLInputElement>) => {
    const fromClipboard = event.clipboardData.getData('text/plain');
    const hasHttpsOrHttp = /^https?:\/\/.*$/.test(fromClipboard);
    // if no protocol 'prefix', behaviour is default and uses the available 'https://' prefix
    if (hasHttpsOrHttp) {
      event.preventDefault();
      const syntheticEvent = {
        target: { name, value: fromClipboard },
        currentTarget: { name, value: fromClipboard },
        preventDefault: () => {},
        stopPropagation: () => {},
        persist: () => {},
        nativeEvent: new Event('input'),
      };
      onChange(syntheticEvent as ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <CustomTextField
      fullWidth
      id={id}
      name={name}
      type="text"
      label={label}
      value={value}
      onChange={onChange}
      onPaste={onURLPaste}
      formErrors={formErrors}
      dbErrors={dbErrors}
      onFocus={onWebsiteFocus}
      {...restProps}
    />
  );
};

export default WebsiteTextField;
